<template>
  <Popover class="menu-popover relative sticky z-10 top-2 mb-4 lg:hidden">
    <PopoverOverlay class="fixed inset-0 bg-white bg-opacity-30 backdrop-blur-sm" />
    <PopoverButton
      class="font-mono flex items-center outline-none gap-2 text-lg sm:text-4 rounded hover:text-stone-400 active:text-stone-600 focus:(text-stone-700 drop-shadow-lg bg-opacity-100) bg-white! bg-opacity-90! backdrop-blur-sm p-1 px-2 rounded-2 -ml-1 transition lg:hidden"
      :class="{ 'drop-shadow': isSticky }"
    >
      <span class="i-material-symbols-menu-rounded"></span>
      Menu</PopoverButton
    >
    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
    >
      <PopoverPanel
        v-slot="{ close }"
        style="width: calc(100% + 1rem); max-height: calc(100dvh - 7.25rem)"
        class="absolute z-2 border-2 border-stone-100 bg-white shadow-lg rounded-4 left-1/2 z-10 mt-2 -translate-x-1/2 transform overflow-auto"
      >
        <Sidebar :ads="false" :isPopover="true" @click="close()" p-3 sm:p-4 />
      </PopoverPanel>
    </transition>
  </Popover>
</template>
<script setup>
import { Popover, PopoverButton, PopoverPanel, PopoverOverlay } from "@headlessui/vue";
import { useWindowScroll } from "@vueuse/core";

const { y } = useWindowScroll();

const isSticky = computed(() => y.value > 10);
</script>
<style>
body:has([data-headlessui-state="open"]) {
  overflow: hidden;
}
.menu-popover:not([data-headlessui-state="open"]) {
  display: inline-block;
}
</style>
